/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: Attest
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 20Jul2022 craig File created.
 \******************************************************************************/
import React, {Fragment, useState} from "react";
import "./Attest.css";
import {GSContext, setSessionCookie} from "../../../context/context";
import {Row, Form, Col, Button} from "react-bootstrap";
import {useRequest} from "../../../helper/useRequest";
import {useLocation, useNavigate} from "react-router-dom";

export const Attest: React.FC = (props) => {

    const navigate = useNavigate();
    const location = useLocation() as any;

    const [sessionUser] = React.useContext(GSContext);
    const [acceptTerms, setAcceptTerms] = useState<string>("");
    const [validated, setValidate] = useState<boolean>(true);

    const attestURL = process.env.REACT_APP_API_URL + "/api/attest/" + sessionUser.UserID;

    const [requestState, setAttestation] = useRequest({url: attestURL, method: "post", withCredentials: true, initialIsLoading: true,})

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {

        const form = event.currentTarget;

        event.stopPropagation();
        event.preventDefault();

        let validated: boolean = false;
        if (form.checkValidity() === false) {
            validated = false;
        }
        else {
            validated = true;
            setAttestation();
            sessionUser.Attested = true;
            setSessionCookie(sessionUser);
            if (location.state?.pathname) {
                navigate(location.state?.pathname);
            }
            else {
                navigate("/");
            }
        }
        setValidate(validated);
    }

    return (
        <Fragment>
            <Row>
                <h2 className={"gold-standard-page-title"}>Please accept the terms and conditions</h2>
            </Row>
            <Form className="form-layout" validated={!validated} onSubmit={handleSubmit} noValidate={true}>
                <Row className={"attest-text"}>
                    <div className={"attest-paragraph"}>CEO Cancer Gold StandardTM applicants have been assured that: Aggregate and anonymized applicant responses may be provided in comparative analysis reports to share Gold Standard progress and best in class to accredited members. There will be no disclosure of individual applicant responses to the general public.</div>
                    <div className={"attest-paragraph"}>By accessing the Gold Standard Application Review Portal, you will have access to organization specific health, wellness and well-being data and agree not to release CEO Cancer Gold Standard application content and/or specific applicant responses without the express written consent of the organization applicant. Accordingly, you agree to keep this information in strictest confidence and will not disclose it to any third party.</div>
                    <div className={"attest-paragraph"}>By checking the box below, you are accepting the Confidentiality Statement.</div>
                </Row>
                <Row className={"mb-3"}>
                    <Form.Group as={Col} className="col-left attest-form" controlId="formBasicEmail">
                        <Form.Check required type={"checkbox"} label={"Accept the terms and conditions"} onChange={(event) => setAcceptTerms(event.target.value)}/>
                        <Form.Control.Feedback type="invalid">
                            Please accept terms & conditions
                        </Form.Control.Feedback>
                    </Form.Group>
                </Row>
                <Button variant="primary" className="btn-submit" type="submit">
                    Accept Terms & Conditions
                </Button>
            </Form>
        </Fragment>
    )

}